import React, { useCallback } from 'react';
import moment, { Moment } from 'moment';
import { useTranslation } from 'react-i18next';
import { IObject } from '@utils/defaultTypes';

import DatePicker from '../index';

interface IQuickRangePicker {
  onChange?: Function;
  defaultValue?: [Moment, Moment];
  style?: IObject;
  value?: any;
  showTime?: boolean;
  allowClear?: boolean;
}

const QuickRangePicker = ({ onChange, ...rest }: IQuickRangePicker) => {
  const { t } = useTranslation('date-picker');

  const handleDate = useCallback(
    (date: any) => {
      onChange &&
        onChange({
          startDate: date && date[0].toISOString(),
          endDate: date && date[1].toISOString(),
        });
    },
    [onChange],
  );

  const ranges = {
    [t('today')]: [
      moment({ hour: 0, minute: 0, second: 0, millisecond: 0 }),
      moment(),
    ],
    [t('last-week')]: [moment().subtract(7, 'days'), moment()],
    [t('last-two-weeks')]: [moment().subtract(14, 'days'), moment()],
    [t('last-three-weeks')]: [moment().subtract(21, 'days'), moment()],
    [t('last-month')]: [moment().subtract(1, 'months'), moment()],
    [t('last-two-months')]: [moment().subtract(2, 'months'), moment()],
    [t('last-three-months')]: [moment().subtract(3, 'months'), moment()],
  };

  return <DatePicker range onChange={handleDate} ranges={ranges} {...rest} />;
};

export default QuickRangePicker;
